import React, { Component } from 'react';
import "./index.less";
import { getPlatformName, messageShow} from '../../utils/http.js';
import { huoyuanLink } from '../../utils/index.js';


class MultiProductSkuMappingModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDailog:false,//是否展示
      products:props.products || [],//商品列表
      selectProduct:null,//当前选中的商品
      
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。

  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    const showDailog = props.showDailog;
    const products = props.products || [];

    if(showDailog != this.state.showDailog)
    {
      
    }

    this.initData(products)
    this.setState({
      showDailog:showDailog,
      products:products,
    })
  }
  initData = (products)=>{
    
    for(const product of products){
      const relations = product.Relation;
      const supplierProducts = product.SupplierProducts;
      const selectProduct = product.ProductFx;

      relations.forEach(x => {
        x.SkuMappings = x.SkuMappings || []
        x.SkuMappings.forEach(mapping => {
          mapping.SourcePlatform = !mapping.SourcePlatform ? 'AlibabaZhuKe' : mapping.SourcePlatform
          mapping.MappingCount = mapping.MappingCount == 0 ? 1 : mapping.MappingCount//如果发现后台返回值的mappingcount为0，改为1
        })
      })
  
      supplierProducts.forEach(supplierProduct => {
        supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform
      })
      for (let supplierProduct of supplierProducts) {
        supplierProduct.Skus = supplierProduct.Skus || [];
        for (let sku of supplierProduct.Skus) {
          sku.lable = sku.Color + sku.Size
          sku.SourcePlatform = supplierProduct.SourcePlatform
        }
      }
  
      selectProduct.Skus = selectProduct.Skus || [];
      const skuMappings = relations.flatMap(x => x.SkuMappings);
      for (let sku of selectProduct.Skus) {
        const mappings = skuMappings.filter(x => x.SkuId == sku.SkuId);

        sku.mappings = mappings.map(x => {
          let SelectSkuTitle = '';
          let SelectSupplierProductName = '';
          for (let i = 0; i < supplierProducts.length; i++) {
            supplierProducts[i].Skus = supplierProducts[i].Skus || [];
            for (let supplierSku of supplierProducts[i].Skus) {
              if (supplierSku.SkuId == x.SupplierSkuId) {
                SelectSkuTitle = supplierSku.lable;
                SelectSupplierProductName = '货源' + (i + 1);
              }
            }
          }

          return {
            SupplierProductId: x.SupplierProductId,
            SourcePlatform: x.SourcePlatform,
            SkuId: x.SkuId,
            SupplierSkuId: x.SupplierSkuId,
            SupplierSpecId: x.SupplierSpecId,
            MappingCount: x.MappingCount,
            RelationCode: x.RelationCode,
            showSupplierProduct: x.SupplierProductId,//页面展示切换货源使用
            SelectSupplierProductName: SelectSupplierProductName,
            SelectSkuTitle: SelectSkuTitle,
            isShowMoreSku: false
          }
        })
        if (sku.mappings.length == 0) {
          sku.mappings.push({
            ProductId: selectProduct.PlatformId,
            SkuId: sku.SkuId,
            MappingCount: 1,
            SelectSupplierProductName: '',
            SelectSkuTitle: '',
            isShowMoreSku: false
          })
        }
      }
    }
    if(products.findIndex(x => x.IsShow) == -1 && products.length > 0){
      products[0].IsShow = true;
      this.state.selectProduct = products[0]
    }
  }
  
  closeProductMapping = () => {
    this.state.selectProduct = null
    this.props.closeProductMapping();
  }
  setMapping(mappings,mapping,supplierProductSku) {
    const hasExists = mappings.filter(x => x.SupplierProductId == supplierProductSku.ProductId && x.SupplierSkuId == supplierProductSku.SkuId && x != mapping)
    if (hasExists.length > 0) {
      messageShow('该供应商规格在组合中已存在！', 'warning')
      return
    }
    if (mapping.mappingCount) {
      if (!(/(^[1-9]\d*$)/.test(mapping.mappingCount))) {
        messageShow("数量必须填正整数的", "warning");
        return;
      }
    }

    const sourceIndex = this.state.selectProduct.SupplierProducts.findIndex(x => supplierProductSku.SourcePlatform == x.SourcePlatform && supplierProductSku.ProductId == x.ProductId)
    mapping.SupplierSkuId = supplierProductSku.SkuId;
    mapping.SupplierProductId = supplierProductSku.ProductId;
    mapping.SourcePlatform = supplierProductSku.SourcePlatform;
    mapping.SelectSkuTitle = supplierProductSku.lable;
    mapping.SelectSupplierProductName = "货源" + (sourceIndex + 1);
    this.showSelectMappings(mapping);
    this.setState({});
  }
  delMapping(mappings, mapping) {
    const index = mappings.findIndex(x => x == mapping)
    if (index > -1) {
      mappings.splice(index, 1)
    }
    this.setState({})
  }
  addMapping(mappings, productSku) {
    mappings.push({
      ProductId: productSku.PlatformId,
      SkuId: productSku.SkuId,
      MappingCount: 1,
    })

    this.setState({})
  }
  setMappingCount(mappingCnt, mapping) {
    mapping.MappingCount = mappingCnt;
    this.setState({})
  }
  selectProduct = (product)=>{
    this.state.selectProduct.IsShow = false;
    product.IsShow = true;
    this.state.selectProduct = product;
    this.setState({})
  }
  showSelectMappings = (mapping) => {
    let selectProduct = this.state.selectProduct;
    const show = !mapping.isShowMoreSku;
    selectProduct.ProductFx.Skus.forEach((item, cIndex) => {
        item.mappings.forEach((cItem, i) => {
          cItem.isShowMoreSku = false;
        })
    })
    mapping.isShowMoreSku = show;
    this.setState({ });
  }
  showSupplierProduct(mapping, supplierProduct) {
    mapping.showSupplierProduct = supplierProduct.ProductId;
    this.setState({})
  }
  hideAllSelectMappings=()=>{
    let selectProduct = this.state.selectProduct;
    if(selectProduct){
      selectProduct.ProductFx.Skus.forEach((item, cIndex) => {
        item.mappings.forEach((cItem, i) => {
            cItem.isShowMoreSku = false;
        })
      })
      this.setState({ })
    }
  }
  stopM = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }
  

  saveSure = async ()=>{
    const data = this.initPostData();
    const mappings = data.Relations.flatMap(x => x.SkuMappings);
    console.log('data =>', data);
    if (data.Relations.length == 0) {
      messageShow('供应商规格不能全部为空', 'warning')
      return
    }
    if (mappings.length == 0) {
      messageShow('供应商规格不能全部为空', 'warning')
      return
    }
    data.sourceData = this.state.selectProduct
    this.props.saveSure(data);
  }

  initPostData = ()=>{
    const product = this.state.selectProduct.ProductFx

    const data = {}
    data.TargetShopId = product.ShopId
    data.TargetShopPt = product.PlatformType
    data.Relations = []
    const mappings = product.Skus.filter(x => x.mappings && x.mappings.length > 0)
      .flatMap(x => x.mappings)
      .filter(x => x.SupplierSkuId && x.MappingCount > 0);
    
    for(const suppliProduct of this.state.selectProduct.SupplierProducts){
      const tempMappinags = mappings.filter(x => x.SupplierProductId == suppliProduct.ProductId && x.SourcePlatform == suppliProduct.SourcePlatform);
      data.Relations.push({
        SupplierProductId : suppliProduct.ProductId,
        SourcePlatform : suppliProduct.SourcePlatform,
        ProductId : this.state.selectProduct.ProductFx.PlatformId,
        SkuMappings : tempMappinags.map(mapping => {
          return{
            SkuId: mapping.SkuId,
            SupplierSkuId: mapping.SupplierSkuId,
            MappingCount: mapping.MappingCount,
          }
        }),
      })
    }
    return data;
  }


  render() {
    const {selectProduct} = this.state;
    
    return (
      <div className="productMappingDailog" id="productMappingDailog" onClick={()=>this.hideAllSelectMappings()}>
        <div className="productMappingDailog-up">
          <span className="productMappingDailog-up-title">商品规格映射</span>
          <i className="iconfont icon-jia-copy1" onClick={() => this.closeProductMapping()}></i>
        </div>
        <div className="productMappingDailog-main">
          <div className="productMappingDailog-left">
            <ul className="productMappingDailog-product">
              {
                this.state.products.map((item) =>
                  <li className={item.IsShow == true ? "active" : ""}  >
                    <div class="dailogSkuMapWrap-up-main" onClick={() => this.selectProduct(item)}>
                      <div class="productShow table-product">
                        <div class="productShow-imgWrap">
                          <img src={item.ProductFx.ImageUrl == null || item.ProductFx.ImageUrl == "" ? "" : item.ProductFx.ImageUrl} alt="" />
                          {
                            item.ProductFx.Status == 'published' ?
                              <span className="product-status">在售中</span> : <span className="product-status" style={{ backgroundColor: "#ff511c" }}>在售中</span>
                          }

                        </div>
                        <ul>
                          <li title="商品标题">{item.ProductFx.Subject}</li>
                          <li className="product-num">
                            <span>售价：￥{item.ProductFx.minPrice}起</span>
                            {/* <span>库存：250</span> */}
                          </li>
                        </ul>
                      </div>
                      <div className="productShow-btns">
                        <span className="productShow-btns-btn" onClick={() => this.selectProduct(item)}>规格映射</span>
                      </div>
                    </div>
                  </li>
                )
              }



            </ul>
          </div>
          <div className="productMappingDailog-right">
            {
              selectProduct != null ?

                <div className="productMappingDailog-right-main">
                  <div className="productMappingDailog-right-mainUp">

                    <div className="purchaseOrdersDailog-table-title" style={{ backgroundColor: "#f6f9fd" }}>
                      {/* 已关联{getPlatformName(selectProduct.ProductFx.PlatformType)}的商品 */}
                      已关联货源商品
                    </div>
                    <div className="dailogSkuMapWrap-up-main scroll-x">

                      {
                        selectProduct.SupplierProducts.map((supplierProduct, index) =>
                          <div className="productShow table-product">
                            <div className="productShow-imgWrap">
                              <img src={supplierProduct.PicURI} alt="" />
                              <span className='productShow-imgWrap-status'>货源{index + 1}</span>
                            </div>
                            <ul>
                              <li title="商品标题">
                                <span className='hover defColor' onClick={() => { huoyuanLink(supplierProduct) }}>{supplierProduct.Subject}</span>
                                {/* <span className='paTag'>
                                  {supplierProduct.SourcePlatform == 'TaoteZhuKe' ? '淘特' :
                                    supplierProduct.IsJxhyOffer == true ? '1688精选' : '1688'}
                                </span> */}
                                {supplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{alignItems: 'center'}}>{supplierProduct.PickupAssr}h晚揽必赔</span>:null}
                              </li>
                              <li className='dangerColor' style={{display:'flex'}}>
                                <span>供应商旺旺：{supplierProduct.SupplierLoginId}</span>
                                {
                                  this.state.isShowDelSupplierProduct ?
                                  <div>
                                    <span className='hover defColor' onClick={()=>{ this.delSupplierProductDialog(supplierProduct,index)}}>删除</span>
                                  </div>:null
                                }
                              </li>
                              {
                                supplierProduct.SourcePlatform == 'TaoteZhuKe' ? 
                                <li className='dangerColor'>! 已不支持淘特货源分销，请更换1688货源</li>:null
                              }
                            </ul>
                          </div>
                        )
                      }
                    </div>
                  </div>

                  <div className="productMappingDailog-right-table">
                    <table className="table-style01">
                      <thead>
                        <tr>

                          <th style={{ width: "150px" }}>{getPlatformName(selectProduct.ProductFx.PlatformType)}规格信息</th>
                          <th style={{ minWidth: "300px" }}>产品信息</th>
                          <th style={{ minWidth: "80px" }}>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          selectProduct.ProductFx.Skus == null || selectProduct.ProductFx.Skus.length == 0 ?
                            <tr><td colSpan="2">没有规格信息</td></tr> :
                            selectProduct.ProductFx.Skus
                            .filter(x => (!selectProduct.filterSkuIds || selectProduct.filterSkuIds.includes(x.SkuId)))
                            .map((item) =>
                                <tr>
                                  <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                  {
                                    item.mappings != null && item.mappings.length > 0 ?
                                      <td>
                                        {
                                          item.mappings.map((supItem, index) =>
                                            <div className='leftRightOperateWrap'>

                                              <div className='leftRightOperate-left '>
                                                <div className='mySelectWrap' onClick={(e)=>this.stopM(e)}>
                                                  <div className="mySelectWrap-titleWrap" onClick={() => this.showSelectMappings(supItem)}>
                                                    {
                                                      supItem.SelectSupplierProductName && supItem.SelectSkuTitle ?
                                                        <span className='mySelectWrap-titleWrap-showTitle'>
                                                          {supItem.SelectSupplierProductName}：
                                                          {supItem.SelectSkuTitle}
                                                        </span> :
                                                        <span className='mySelectWrap-titleWrap-title'>请选择</span>

                                                    }
                                                    <i className={supItem.isShowMoreSku ? 'mySelectWrap-titleWrap-icon active' : 'mySelectWrap-titleWrap-icon'}></i>
                                                  </div>

                                                  <div className={supItem.isShowMoreSku ? "mySelectWrap-content active" : "mySelectWrap-content"}>
                                                    <ul className='mySelectWrap-content-left scroll-x'>
                                                      {
                                                        selectProduct.SupplierProducts.map((supplierProduct, index02) =>
                                                          supItem.showSupplierProduct == supplierProduct.ProductId ?
                                                            <li checked className='content-left-item hover defColor' onClick={() => { this.showSupplierProduct(supItem, supplierProduct, (index02 + 1),false) }}>
                                                              <span className='content-left-item-title'>货源{index02 + 1}</span>
                                                              <span className='iconfont icon-xiangxia'></span>
                                                            </li>
                                                            : <li className='content-left-item hover' onClick={() => { this.showSupplierProduct(supItem, supplierProduct, (index02 + 1),true) }}>
                                                              <span className='content-left-item-title'>货源{index02 + 1}</span>
                                                              <span className='iconfont icon-xiangxia'></span>
                                                            </li>
                                                        )
                                                      }
                                                    </ul>
                                                    <ul className='mySelectWrap-content-right scroll-x'>
                                                      {
                                                        selectProduct.SupplierProducts
                                                          .filter(x => x.ProductId == supItem.showSupplierProduct).flatMap(x => x.Skus)
                                                          .map((sku, index02) =>
                                                            sku.ProductId == supItem.SupplierProductId && sku.SkuId == supItem.SupplierSkuId ?
                                                              <li checked className='content-right-item over defColor'  onClick={(() => { this.setMapping(item.mappings,supItem, sku) })}>
                                                                <span className='content-right-item-title'>{sku.lable}</span>
                                                              </li>
                                                              : <li className='content-right-item hover' onClick={(() => { this.setMapping(item.mappings,supItem, sku) })}>
                                                                <span className='content-right-item-title'>{sku.lable}</span>
                                                              </li>
                                                          )
                                                      }
                                                    </ul>
                                                  </div>
                                                </div>


                                              </div>

                                              <input className='leftRightOperate-right' type='number' value={supItem.MappingCount} onChange={(e) => this.setMappingCount(e.target.value, supItem)}></input>
                                              {
                                                item.mappings.length > 1 ?
                                                  <span className='dangerColor hover' onClick={(e) => this.delMapping(item.mappings, supItem)}>删除</span> :
                                                  null
                                              }
                                            </div>
                                          )
                                        }
                                      </td> : null
                                  }
                                  <td><span className='smaDefBtn' onClick={(e) => this.addMapping(item.mappings, item)}>添加规格</span></td>
                                </tr>
                            )
                        }


                      </tbody>
                    </table>
                  </div>
                </div>

                : null
            }



          </div>
        </div>
        <div className="productMappingDailog-footer">
          <span type="primary" className='sureMyBtn' style={{ width: "200px",textAlign:'center' }} onClick={() => this.saveSure()}>确定</span>
        </div>
        <div className="productMappingDailog-leftClose" onClick={() => this.closeProductMapping()}>
          <i className="iconfont icon-down"></i>
        </div>


      </div>
    );
  }



};

export default MultiProductSkuMappingModule;



// WEBPACK FOOTER //
// ./src/components/multiProductSkuMappingModule/index.jsx